export const COURSE_PAUSE_MODAL_STAGES = {
  notOpen: 'notOpen',
  manage: 'manage',
  success: 'success',
};
